import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/A7';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得部分投資終止轉換條款說明
export function getAgreeTermsA7() {
    return get(`${url}/getAgreeTerms`);
};

// 部分投資終止條款同意
export function postAgreeA7() {
    return post(`${url}/agree`);
};

/**
 * 保戶部分投資終止前，取得先前投資標的記錄
 * @return {Object}
 */
export function getInfoA7() {
    return get(`${url}/info`);
};

// 送出部分投資終止申請變更
// "redeemDtoList": [
//     {
//       "fundCode": "string",
//       "redeemUnit": 0,
//       "redeemNum": 0
//     }
//   ]
export function submitA7(data) {
    return post(`${url}/submit`, data, { ...options, errorDialog: false, repeatRequestCancel: true });
};

/**
 * 送出單筆增額投資金額申請-顯示申購手續費
 * @return {Object}
 */
export function fundCodeInfo(data){
    return post(`${url}/fundCodeInfo`,data,{ ...options,repeatRequestCancel : true});
};
